import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, ToastController } from 'ionic-angular';
import { Sadhona } from '../../providers/sadhona';

/**
 * Generated class for the EmailSadhanaPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-email-sadhana',
  templateUrl: 'email-sadhana.html',
})
export class EmailSadhanaPage {
  fromMonth: any;
  toMonth: any;
  isMobile = false;
  today = new Date().getFullYear() + '-' + this.appendZero((new Date().getMonth() + 1))
  constructor(public navCtrl: NavController, public navParams: NavParams, private alertCtrl: AlertController, private sadhona: Sadhona,
                  private toastCtrl: ToastController) {
  }

  ionViewDidLoad() {
    if (window.innerWidth < 800) {
      this.isMobile = true;
    }
    console.log(typeof this.today)
    console.log('ionViewDidLoad EmailSadhanaPage');
  }

  appendZero(val: number) {
    return val < 10 ? '0' + val : val;
  }
  sendEmail () {
    console.log(this.fromMonth)
    console.log(this.toMonth)
    if (this.checkValidation()) {
      this.presentAlert('Error', this.checkValidation())
      return false;
    }

    this.sadhona.sendSadhanaReportEmail(this.fromMonth, this.toMonth).subscribe(
      (res: any) => {
        this.presentToast('Email has been sent successfully')
      }
    )
  }

  presentToast(msg) {
    let toast = this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top',
      showCloseButton: true
    });
    toast.present();
  }

  monthDiff(fy, fm, ty, tm) {
    let months;
    months = (Number(ty) - Number(fy)) * 12;
    months -= Number(fm);
    months += Number(tm);
    return months <= 0 ? 0 : months;
  }


  checkValidation () {
    const fdate = this.fromMonth.split('-')
    const tdate = this.toMonth.split('-')
 
    if (fdate.length == 2 && tdate.length == 2) {
      if ((Number(fdate[0]) - Number(tdate[0])) > 1) {
        return 'You can select maximum 12 month';
      } else {
        const totalmonth = this.monthDiff(fdate[0], fdate[1], tdate[0], tdate[1])
        if (totalmonth > 12 || totalmonth <= 0) {
          return 'You can select maximum 12 month';
        }
        return false;
      }
    } else {
      return 'Please select from and to month';
    }
  }

  presentAlert(title, msg) {
    let alert = this.alertCtrl.create({
      title: title,
      subTitle: msg,
      buttons: ['Dismiss']
    });
    alert.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/email-sadhana/email-sadhana.ts